import apiWrapper from '../../../common/api/api-wrapper';
import {
	IAPIErrorContent,
	IPrioritizationParams,
} from '../../../common/api/type-def';

import {
	IRiskAndRegChangeToWatch,
	IMyApprovalsTableData,
	IActionReviewPayload,
	ISubmitChangesPayload,
} from './type-def';

const { REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL } = process.env;

export const getAllMyTasks = async (params: any) => {
	let sortKey = '';
	if (params.sortKey) {
		if (params.sortKey === 'priorityLevel') {
			sortKey = 'taskImportance';
		} else if (params.sortKey === 'dueDate') {
			sortKey = 'targetEndDate';
		} else {
			sortKey = params.sortKey;
		}
	}
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const sort = sortKey !== '' ? `${sortKey},${sortDirection}` : '';
	const resp = await apiWrapper.get<any, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/task-manager/user/${params.userId}/tasks?filterText=${params?.filterText}&page=${params?.pageNumber}&size=${params?.pageSize}&sort=${sort}`,
	);

	return resp;
};

export const getRiskAndRegChangeToWatch = async (
	params: IPrioritizationParams,
) => {
	const resp = await apiWrapper.get<
		IRiskAndRegChangeToWatch[],
		IAPIErrorContent
	>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/incoming-risk-regulation?startDate=${params.startDate}&endDate=${params.endDate}`,
	);

	return resp;
};

export const getMyApprovalTableData = async (
	params: any,
	searchText: string,
	status: string[],
) => {
	const resp = await apiWrapper.get<IMyApprovalsTableData, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/audit/my-approval?filterType=${status}&filterText=${encodeURIComponent(
			searchText,
		)}&page=${params.pageNumber}&size=${params.pageSize}`,
	);
	return resp;
};

export const getMyApprovalChangesTabData = async (
	entityId: string,
	status: string,
) => {
	const resp = await apiWrapper.get<IActionReviewPayload[], IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/audit/my-approval/changes?entityId=${entityId}&reviewStatus=${status}`,
	);
	return resp;
};

export const updateMyChanges = async (data: ISubmitChangesPayload) => {
	const resp = await apiWrapper.post<unknown, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/audit/my-approval/changes`,
		data,
	);
	return resp;
};

export const downloadFile = async (name: string, type: string) => {
	const resp = await apiWrapper.get<unknown, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/file/download?fileName=${name}&dataType=${type}`,
	);
	return resp;
};
